import { CMIErrorCode } from './scorm2004-api';

export class ScormError {
  constructor(
    public readonly code: CMIErrorCode,
    public readonly message: string,
    public readonly diagnostic: string = message) {
  }
}
